import { useQuery } from '@Helper/utils';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Icons } from '../../assets/SvgIcons';
import Header from '../../components/Layout/Header/Header';
import LayoutContainer from '../../components/Layout/LayoutContainer';
import { FilterIProps } from '../../config/filter';
import { getPlayBookDetail } from '../../store/feature/playBookDetailSlice';
import { useAppSelector } from '../../store/hooks';
import BoardTab from './Tabs/BoardTab';
import ListTab from './Tabs/ListTab';
import OverviewTab from './Tabs/OverviewTab';

interface propState {
  tabValue: string;
  filteredPlayBookId?: FilterIProps;
}

export default function DependenciesImo() {
  let navigate = useNavigate();
  const { id } = useParams();
  let query = useQuery();
  const tabIndex = query.get('tabIndex');
  let initialTabValue = tabIndex || '1';
  let filteredPlayBookId: FilterIProps | undefined = undefined;
  const location = useLocation();
  if (location.state as propState) {
    initialTabValue = (location.state as propState).tabValue;
    filteredPlayBookId = (location.state as propState).filteredPlayBookId;
  }
  const [tabValue, setTabValue] = useState(initialTabValue);
  const { dealTaskList } = useAppSelector(getPlayBookDetail);
  console.log(
    'dealTask',
    dealTaskList.filter(t => t.type === 'dependency' && !t.isArchived)
  );

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    console.log('alejandro', { newValue });
    navigate('/dependencies/' + id + `?tabIndex=${newValue}`);
    setTabValue(newValue);
    setdirectedFilters([]);
  };
  const [directedFilters, setdirectedFilters] = useState<FilterIProps[]>([]);

  useEffect(() => {
    tabIndex && setTabValue(tabIndex);
  }, [tabIndex]);
  const { t } = useTranslation();
  return (
    <LayoutContainer>
      <TabContext value={tabValue}>
        <Header
          headerLeft={
            <div className="headerTitleContiner">
              <div>
                <Icons.DependencyHeader
                  color="#5243aa"
                  width={30}
                  height={30}
                />
              </div>
              <div className="headerTitle">
                {t('dependencies.dependencies_header')}
              </div>
            </div>
          }
        ></Header>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} className="playbookTabList">
            <Tab label={t('dependencies.overview')} value="1" />
            <Tab label={t('dependencies.list')} value="2" />
            {/* <Tab label="Board" value="3" /> */}
          </TabList>
        </Box>
        <TabPanel value="1" className="playbookTabPanel">
          <OverviewTab
            dealTaskList={dealTaskList.filter(
              t =>
                t.type === 'dependency' &&
                t.projectRelType === 'target' &&
                !t.isArchived
            )}
            setdirectedFilters={setdirectedFilters}
            setTabValue={setTabValue}
            isImo={true}
          />
        </TabPanel>
        <TabPanel value="2" className="playbookTabPanel" style={{ padding: 0 }}>
          <ListTab
            taskList={dealTaskList.filter(i => !i.isArchived)}
            filteredPlayBookId={filteredPlayBookId}
            directedFilters={directedFilters}
            isImo={true}
          />
        </TabPanel>
        <TabPanel value="3" className="playbookTabPanel" style={{ padding: 0 }}>
          <BoardTab
            myTaskList={dealTaskList.filter(
              t => t.type === 'dependency' && !t.isArchived
            )}
          />
        </TabPanel>
      </TabContext>
    </LayoutContainer>
  );
}
